var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 29.75C16.3125 30.4628 16.5956 31.1463 17.0997 31.6503C17.6037 32.1544 18.2872 32.4375 19 32.4375C19.7128 32.4375 20.3963 32.1544 20.9003 31.6503C21.4044 31.1463 21.6875 30.4628 21.6875 29.75C21.6875 29.0372 21.4044 28.3537 20.9003 27.8497C20.3963 27.3456 19.7128 27.0625 19 27.0625C18.2872 27.0625 17.6037 27.3456 17.0997 27.8497C16.5956 28.3537 16.3125 29.0372 16.3125 29.75ZM19 21.6875C18.2872 21.6875 17.6037 21.4044 17.0997 20.9003C16.5956 20.3963 16.3125 19.7128 16.3125 19C16.3125 18.2872 16.5956 17.6037 17.0997 17.0997C17.6037 16.5956 18.2872 16.3125 19 16.3125C19.7128 16.3125 20.3963 16.5956 20.9003 17.0997C21.4044 17.6037 21.6875 18.2872 21.6875 19C21.6875 19.7128 21.4044 20.3963 20.9003 20.9003C20.3963 21.4044 19.7128 21.6875 19 21.6875ZM19 10.9375C18.2872 10.9375 17.6037 10.6544 17.0997 10.1503C16.5956 9.64635 16.3125 8.96277 16.3125 8.25C16.3125 7.53723 16.5956 6.85366 17.0997 6.34965C17.6037 5.84565 18.2872 5.5625 19 5.5625C19.7128 5.5625 20.3963 5.84565 20.9003 6.34965C21.4044 6.85366 21.6875 7.53723 21.6875 8.25C21.6875 8.96277 21.4044 9.64635 20.9003 10.1503C20.3963 10.6544 19.7128 10.9375 19 10.9375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.13e780560bca61631e432758c5af9b0f.svg";
export { ForwardRef as ReactComponent };